import { useState } from "react";
import type { BobState, PromptFormat } from "../types";
import { forgePrompt } from "../lib/engine/promptForge";
import { copyToClipboard } from "../lib/storage";

interface Props {
  state: BobState;
  onUpdate: (partial: Partial<BobState>) => void;
  toast: (msg: string) => void;
}

export function PromptForgePanel({ state, onUpdate, toast }: Props) {
  const [intent, setIntent] = useState("");
  const [format, setFormat] = useState<PromptFormat>("cursor");
  const latest = state.prompts[state.prompts.length - 1];
  const latestIntake = state.intakes[state.intakes.length - 1];

  function generate() {
    if (!intent.trim()) {
      toast("Enter build intent first.");
      return;
    }
    const result = forgePrompt({ intent, format, intakeId: latestIntake?.id }, latestIntake);
    onUpdate({ prompts: [...state.prompts, result] });
    toast(`Prompt forged: ${format}`);
  }

  async function copyLatest() {
    if (!latest) return;
    const ok = await copyToClipboard(latest.markdown);
    toast(ok ? "Copied to clipboard" : "Copy failed");
  }

  return (
    <section className="surface glass-panel">
      <h2>Prompt Forge</h2>
      <p className="lead">Convert intent into builder handoff prompts — local generation only.</p>
      <div className="form-grid">
        <label>
          Build intent
          <textarea value={intent} onChange={(e) => setIntent(e.target.value)} placeholder="What should the builder do?" />
        </label>
        <label>
          Export format
          <select value={format} onChange={(e) => setFormat(e.target.value as PromptFormat)}>
            <option value="cursor">Cursor prompt</option>
            <option value="claude-code">Claude Code prompt</option>
            <option value="lovable">Lovable prompt</option>
            <option value="local-build">Local build prompt</option>
          </select>
        </label>
      </div>
      <div className="btn-row">
        <button type="button" className="btn" onClick={generate}>
          Forge prompt
        </button>
        <button type="button" className="btn secondary" onClick={copyLatest} disabled={!latest}>
          Copy markdown
        </button>
      </div>
      {latest && <pre className="output-box">{latest.markdown}</pre>}
    </section>
  );
}
